module.exports = __webpack_public_path__ + "static/media/112.39c274e9.jpg";